var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    fill: "none",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12,2C6.486,2,2,6.487,2,12c0,5.515,4.486,10,10,10s10-4.485,10-10C22,6.487,17.514,2,12,2z M12,18.25 c-0.69,0-1.25-0.559-1.25-1.25c0-0.69,0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25C13.25,17.691,12.69,18.25,12,18.25z M13,13.875V15 h-2v-3h1c1.104,0,2-0.897,2-2c0-1.104-0.896-2-2-2s-2,0.896-2,2H8c0-2.205,1.795-4,4-4s4,1.795,4,4 C16,11.861,14.723,13.429,13,13.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.484abe75b4fda053c3d4cc41fe7ea2f5.svg";
export { ForwardRef as ReactComponent };